import React from "react";

import MainLayout from "components/MainLayout";
import Header from "components/Header";

type Props = {
  content: React.ReactNode;
  header?: React.ReactNode;
  hasHeader: boolean;
};

function PageLayout({ content, hasHeader, header }: Props): JSX.Element {
  return (
    <div>
      {hasHeader ? (
        <MainLayout header={header || <Header />} content={content} />
      ) : (
        <MainLayout content={content} />
      )}
    </div>
  );
}

PageLayout.defaultProps = {
  content: null,
  hasHeader: true,
  header: null,
};

export default PageLayout;
